import {connect} from 'react-redux';
import QCReportsContainer from './QCReportsContainer';
import {createNewQcReportNoteAction} from './qc-reports-notes/Redux/QCReportsNotesActions';
import {QCReportsNotesState} from '../qc-reports/QCReportsReasonsTypes';
import {updateQcJobReportStatusAction} from './Redux/QCReportsActions';
import {QcJobStatusIndicatorState} from '../../QCTools/JobStatusIndicator/JobStatusIndicatorTypes';

interface State {
    qcJobs: {
        qcReportsNotes: QCReportsNotesState,
    },
    qcTools: {
        statusIndicators: QcJobStatusIndicatorState,
    },
}

export const mapState = (state: State) => {
    const {qcTools, qcJobs} = state;
    const {statusIndicators} = qcTools;
    
    return {
        ...statusIndicators,
        qcReportsNotes: qcJobs.qcReportsNotes,
    };
};

export const mapDispatch = {
    createNewQcReportNote: createNewQcReportNoteAction,
    updateQcJobReportStatus: updateQcJobReportStatusAction,
};

export default connect(mapState, mapDispatch)(QCReportsContainer);
